<template>
  <v-btn :ripple="false" v-bind="$attrs" v-on="$listeners" depressed>
    <slot />
  </v-btn>
</template>

<script>
export default {
  name: "TkBtn",
  inheritAttrs: false
};
</script>

<style lang="scss">
.v-btn {
  &.theme--light {
    &.accent {
      color: #000;
    }
  }

  &.search-btn {
    height: 40px;
    font-size: 0.8rem;
  }
}
</style>
